import CassinosView from "../../sections/Admin/Cassinos/CassinosView";

const Cassinos = () => {
    return (
        <CassinosView />
    )
}
export default Cassinos;